import { FaCheck } from 'react-icons/fa6';

/* The 4 setup steps, shown as a vertical, cascading stepper in the builder's
   left sidebar. Completed steps are revisitable; future steps unlock only up to
   the furthest step reached (PRD §5). */
const STEPS = [
	{ id: 'channel', label: 'Source channel', desc: 'The channel we dub from.' },
	{ id: 'videos', label: 'Videos', desc: 'Which uploads to dub.' },
	{ id: 'langs', label: 'Languages & destinations', desc: 'Target languages, and where each dub gets posted.' },
	{ id: 'golive', label: 'Review & activate', desc: 'Check the setup, then turn it on.' },
];

export default function BuilderSidebar({ current, maxReached, onGo }) {
	return (
		<nav className="flex flex-col">
			{STEPS.map((s, i) => {
				const done = i < current;
				const cur = i === current;
				const reachable = i <= maxReached;
				const last = i === STEPS.length - 1;
				return (
					<button
						key={s.id}
						type="button"
						onClick={() => reachable && onGo(i)}
						disabled={!reachable}
						className={`group relative flex gap-3.5 text-left ${reachable ? 'cursor-pointer' : 'cursor-default'} ${last ? '' : 'pb-7 md:pb-8'}`}
					>
						{/* connector line dropping from this circle toward the next step */}
						{!last && (
							<span
								className="absolute left-[17px] top-9 bottom-1 w-px"
								style={{ background: done ? '#16c098' : '#e3e6ec' }}
							/>
						)}

						{/* numbered circle */}
						<span
							className="relative z-10 w-9 h-9 rounded-full grid place-items-center text-[13.5px] font-bold flex-none transition"
							style={{
								background: cur ? '#0f172a' : done ? '#16c098' : '#eef0f4',
								color: cur || done ? '#fff' : '#9aa3b2',
								boxShadow: cur ? '0 0 0 4px rgba(15,23,42,0.08)' : 'none',
							}}
						>
							{done ? <FaCheck size={14} /> : i + 1}
						</span>

						{/* label + description */}
						<span className="min-w-0 pt-1">
							<span className={`block text-[14px] font-bold leading-tight ${cur ? 'text-slate-900' : done ? 'text-slate-700' : 'text-slate-400'}`}>{s.label}</span>
							<span className="mt-1.5 hidden md:block text-[12.5px] leading-relaxed text-slate-400">{s.desc}</span>
						</span>
					</button>
				);
			})}
		</nav>
	);
}
